// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c6d10060","348":"8df737b1","456":"a32f7732","888":"8df737b1","964":"1f9d5324"}[chunkId] + ".chunk.css";
};